import { render } from "./EnhancedDocumentViewer.vue?vue&type=template&id=15b80d5d&scoped=true"
import script from "./EnhancedDocumentViewer.vue?vue&type=script&lang=js"
export * from "./EnhancedDocumentViewer.vue?vue&type=script&lang=js"

import "./EnhancedDocumentViewer.vue?vue&type=style&index=0&id=15b80d5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b80d5d"]])

export default __exports__